import { Pipe, PipeTransform } from '@angular/core';

import { clienteTiposFiscais } from '../cliente-tipo-fiscal';

@Pipe({
    name: 'clienteTipoFiscal'
})
export class ClienteTipoFiscalPipe implements PipeTransform {
    transform(value: number): string {
        if (!value) {
            return '';
        }

        const index = clienteTiposFiscais.findIndex(tipoFiscal => tipoFiscal.id === value);
        if (index > -1) {
            return clienteTiposFiscais[index].nome;
        }
        return '';
    }
}
